exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#footer[data-v-7d2700f6]{background-color:#232127}h1[data-v-7d2700f6]{color:#fff}li[data-v-7d2700f6]{color:#bfbfbf;margin-bottom:10px}.footer-list[data-v-7d2700f6],ul[data-v-7d2700f6]{display:flex;flex-direction:column;align-items:start}.footer-list[data-v-7d2700f6]{gap:20px}@media (max-width:540px){.footer-list[data-v-7d2700f6],ul[data-v-7d2700f6]{align-items:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d2700f6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 30
// module chunks = 0